<div class="minimap-card" [class.minimap-collapsed]="collapsed">

  <div class="minimap-header">
    <span class="minimap-title">Tu ubicación</span>
    <div class="minimap-header-actions">
      <button *ngIf="isZoomed" class="minimap-reset" (click)="resetZoom()" title="Restablecer zoom">
        <i class="fa-light fa-compress"></i>
      </button>
      <button class="minimap-toggle" (click)="toggleCollapse()"
        [attr.aria-label]="collapsed ? 'Expandir mapa' : 'Minimizar mapa'">
        <i class="fa-light" [class.fa-chevron-up]="!collapsed" [class.fa-chevron-down]="collapsed"></i>
      </button>
    </div>
  </div>

  <div class="minimap-body" *ngIf="!collapsed">
    <svg *ngIf="svgElements.length > 0"
      #svgEl
      [attr.viewBox]="svgViewBoxDynamic"
      [attr.width]="MINIMAP_W"
      [attr.height]="MINIMAP_H"
      xmlns="http://www.w3.org/2000/svg"
      [class.is-zoomed]="isZoomed"
      [class.is-dragging]="isDragging"
      (wheel)="onWheel($event, svgEl)"
      (mousedown)="onMouseDown($event)"
      (mousemove)="onMouseMove($event)"
      (mouseup)="onMouseUp()"
      (mouseleave)="onMouseLeave()"
      (dblclick)="resetZoom()">

      <ng-container *ngFor="let el of svgElements">

        <polygon *ngIf="el.svgType === 'polygon'"
          [attr.points]="el.points"
          [attr.fill]="el.fill"
          [attr.fill-opacity]="el.opacity"
          [attr.stroke]="el.isSelected ? '#FF4D80' : el.stroke"
          [attr.stroke-width]="el.strokeWidth"
          [style.cursor]="el.isZone && !el.isSelected ? 'pointer' : 'inherit'"
          (click)="onZoneClick(el)">
        </polygon>

        <rect *ngIf="el.svgType === 'rect' || el.svgType === 'scenary'"
          [attr.x]="el.x" [attr.y]="el.y"
          [attr.width]="el.width" [attr.height]="el.height"
          [attr.fill]="el.fill"
          [attr.fill-opacity]="el.opacity"
          [attr.stroke]="el.isSelected ? '#FF4D80' : el.stroke"
          [attr.stroke-width]="el.strokeWidth"
          [attr.transform]="el.transform || null"
          [style.cursor]="el.isZone && !el.isSelected ? 'pointer' : 'inherit'"
          (click)="onZoneClick(el)">
        </rect>

        <ellipse *ngIf="el.svgType === 'ellipse'"
          [attr.cx]="el.cx" [attr.cy]="el.cy"
          [attr.rx]="el.rx" [attr.ry]="el.ry"
          [attr.fill]="el.fill"
          [attr.fill-opacity]="el.opacity"
          [attr.stroke]="el.isSelected ? '#FF4D80' : el.stroke"
          [attr.stroke-width]="el.strokeWidth"
          [attr.transform]="el.transform || null"
          [style.cursor]="el.isZone && !el.isSelected ? 'pointer' : 'inherit'"
          (click)="onZoneClick(el)">
        </ellipse>

        <path *ngIf="el.svgType === 'line'"
          [attr.d]="el.pathD"
          fill="none"
          [attr.stroke]="el.stroke"
          [attr.stroke-width]="el.strokeWidth"
          stroke-linecap="round"
          [style.cursor]="'inherit'">
        </path>

        <text *ngIf="el.isScenary && el.label"
          [attr.x]="el.labelX" [attr.y]="el.labelY"
          [attr.font-size]="el.fontSize"
          font-family="Satoshi-Regular, sans-serif"
          text-anchor="middle" dominant-baseline="middle"
          fill="#444" pointer-events="none" font-style="italic">
          {{ el.label }}
        </text>

      </ng-container>
    </svg>

    <p *ngIf="!svgElements.length" class="minimap-empty">Vista general no disponible</p>
  </div>

</div>
